import React from "react";
import styled from "styled-components";

const Icon = styled.svg`
  display: block;
`;

const Copy = () => (
  <Icon
    xmlns="http://www.w3.org/2000/svg"
    width="18.792"
    height="18.793"
    viewBox="0 0 18.792 18.793"
    fill="currentColor"
  >
    <path
      d="M17.825,11.472l-2.4-2.4a3.336,3.336,0,0,0-4.744.046L9.673,8.11A3.239,3.239,0,0,0,10.686,5.7,3.179,3.179,0,0,0,9.73,3.365L7.358.982A3.155,3.155,0,0,0,5.009,0,3.18,3.18,0,0,0,2.671.959L.979,2.64A3.142,3.142,0,0,0,0,4.978,3.2,3.2,0,0,0,.967,7.327l2.4,2.4a3.2,3.2,0,0,0,2.349.967,3.225,3.225,0,0,0,2.4-1.013L9.12,10.689A3.239,3.239,0,0,0,8.107,13.1a3.18,3.18,0,0,0,.956,2.338l2.372,2.383a3.322,3.322,0,0,0,4.686.023l1.693-1.681a3.143,3.143,0,0,0,.979-2.338A3.2,3.2,0,0,0,17.825,11.472ZM8.107,6.544l-.213-.219q-.178-.184-.247-.248A2.784,2.784,0,0,0,7.427,5.9a.928.928,0,0,0-.294-.15,1.173,1.173,0,0,0-.317-.04A1.1,1.1,0,0,0,5.712,6.82a1.173,1.173,0,0,0,.04.317.924.924,0,0,0,.15.294,2.77,2.77,0,0,0,.173.219q.063.069.247.248l.219.213a1.113,1.113,0,0,1-.829.357,1.062,1.062,0,0,1-.783-.311l-2.4-2.4a1.067,1.067,0,0,1-.322-.783,1.052,1.052,0,0,1,.322-.771L4.226,2.525a1.112,1.112,0,0,1,.783-.311,1.066,1.066,0,0,1,.783.322L8.164,4.92a1.066,1.066,0,0,1,.322.783A1.118,1.118,0,0,1,8.107,6.544Zm8.153,8.048-1.693,1.681a1.11,1.11,0,0,1-.783.3A1.061,1.061,0,0,1,13,16.262l-2.372-2.384a1.066,1.066,0,0,1-.322-.783,1.117,1.117,0,0,1,.38-.841l.213.219q.178.184.248.248a2.734,2.734,0,0,0,.219.173.923.923,0,0,0,.294.15,1.171,1.171,0,0,0,.317.04,1.1,1.1,0,0,0,1.106-1.105,1.18,1.18,0,0,0-.04-.317.921.921,0,0,0-.15-.294,2.781,2.781,0,0,0-.173-.219q-.063-.069-.248-.248l-.219-.213a1.1,1.1,0,0,1,.829-.369,1.065,1.065,0,0,1,.783.322l2.4,2.395a1.066,1.066,0,0,1,.322.783A1.052,1.052,0,0,1,16.26,14.592Z"
      transform="translate(18.795) rotate(90)"
    />
  </Icon>
);

export default Copy;



// WEBPACK FOOTER //
// ./src/components/Icons/Copy.js